import React from "react";
import Modal, { ModalProps } from "components/Modal";
import AdvancedProductSearch, { ProductSearchProps } from ".";
import { productSearchStore } from "./ProductSearchStore";

const ProductSearchModal = (props: ProductSearchProps & ModalProps) => {
  React.useEffect(() => {
    productSearchStore.setIsOpened(props.open);

    return () => productSearchStore.setIsOpened(false);
  }, [props.open]);

  return (
    <Modal
      isOpen={props.open}
      setIsOpen={props.close}
      className="p-6 flex flex-col overflow-visible overflow-x-hidden relative"
      containerClassName="md:min-w-[1280px]"
      position="top"
    >
      <AdvancedProductSearch {...props} closeModal={props.close} />
    </Modal>
  );
};

export default ProductSearchModal;
